// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3DL4B","title":"InfoRow_title__3Sq6_"};